import axios from 'axios';

const { REACT_APP_BACKEND_URL } = process.env;

export const login = ({ username, password }) => {
  return axios.post(`${REACT_APP_BACKEND_URL}/auth/login`, { email: username, password });
};

export const check = () => {
  const token = localStorage.getItem('viBBes_token');
  if (!token) return Promise.reject();

  const headers = {
    authorization: token,
  };
  return axios.get(`${REACT_APP_BACKEND_URL}/auth/me`, { headers });
};

export const checkSignUpToken = token => {
  return axios.post(`${REACT_APP_BACKEND_URL}/auth/${token}/check`);
};

export const signUp = (token, data) => {
  return axios.post(`${REACT_APP_BACKEND_URL}/auth/${token}/signup`, data);
};

export const forgotPassword = (data) => {
  return axios.post(`${REACT_APP_BACKEND_URL}/auth/forgot-password`, data);
};

export const checkPasswordResetToken = (token) => {
  return axios.get(`${REACT_APP_BACKEND_URL}/auth/password-reset/${token}`);
};

export const passwordReset = (token, data) => {
  return axios.post(`${REACT_APP_BACKEND_URL}/auth/password-reset/${token}`, data);
};

export const invite = data => {
  const token = localStorage.getItem('viBBes_token');
  if (!token) return Promise.reject();

  const headers = {
    authorization: token,
  };

  return axios.post(`${REACT_APP_BACKEND_URL}/auth/invite`, data, { headers });
};
